import SubHeadline from './SubHeadline';

export default SubHeadline;
